export type PresetRange = '7d' | '30d' | '90d' | '1y' | 'all' | 'custom';

function toDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * 根据预设计算 [from, to]，全部时返回空串
 */
export function computePresetRange(preset: PresetRange): { from: string; to: string } {
  if (preset === 'all' || preset === 'custom') return { from: '', to: '' };
  const now = new Date();
  const to = toDateStr(now);
  const map: Record<string, number> = { '7d': 7, '30d': 30, '90d': 90, '1y': 365 };
  const days = map[preset] ?? 30;
  const from = new Date(now);
  from.setDate(from.getDate() - days + 1);
  return { from: toDateStr(from), to };
}